import { TState } from '~/src/store';

const selectAgreements = (state: TState) => {
    return state.agreements.list;
};

export default selectAgreements;
